import { ClientUser } from "@/model/data/authentication/ClientUser";
import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class FetchClientUsersResponse extends ServiceResponseData {
    clientUsers: ClientUser[] = [];

    constructor(response: AxiosResponse) {
        super(response);
        if (response && response.data.Payload) {
            response.data.Payload.forEach((u) => {
                this.clientUsers.push(ClientUser.parseFrom(u));
            });
        }
    }
}
